interface GenerationContextSelection {
  readonly level: string;
  readonly module: string;
  readonly section: string | number;
}

/**
 * Speaking prompts that are presented to the learner as text and must not be
 * converted into generated audio.
 */
export function usesTextOnlySpeakingContext({
  level,
  module,
  section,
}: GenerationContextSelection): boolean {
  return (
    module === 'speaking' &&
    (level === 'B1' || (level === 'A1' && Number(section) === 3))
  );
}
